import { Download, FileSpreadsheet, FileText } from 'lucide-react';
import * as React from 'react';

import {
  Button, DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger,
} from '@/components/cargofl-ui';

/**
 * One control offering both formats.
 *
 * Two side-by-side buttons would say "these are different things"; they are the
 * same data twice, and which one somebody wants depends on what they are about to
 * do with it - open it, or feed it to something. So it is one action with a
 * choice, and the choice is named by what the file IS rather than by its
 * extension.
 */
export function ExportMenu({
  label = 'Export',
  onCsv,
  onXlsx,
  disabled,
}: {
  label?: string;
  onCsv: () => void;
  onXlsx: () => void | Promise<void>;
  disabled?: boolean;
}) {
  const [busy, setBusy] = React.useState(false);

  // The Excel writer is fetched on demand, so the click can take a moment the
  // first time. Saying so beats a button that appears to have done nothing.
  const runXlsx = async () => {
    setBusy(true);
    try {
      await onXlsx();
    } finally {
      setBusy(false);
    }
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button hint={"Download in this format"} variant="outline" size="sm" disabled={disabled || busy}>
          <Download className="size-4" />
          {busy ? 'Preparing…' : label}
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <DropdownMenuItem onSelect={() => void runXlsx()}>
          <FileSpreadsheet className="size-4" />
          Excel workbook
        </DropdownMenuItem>
        <DropdownMenuItem onSelect={onCsv}>
          <FileText className="size-4" />
          CSV
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
